import script from "./kpiSection.vue?vue&type=script&setup=true&lang=js"
export * from "./kpiSection.vue?vue&type=script&setup=true&lang=js"

import "./kpiSection.vue?vue&type=style&index=0&id=7fa6260d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa6260d"]])

export default __exports__